export const cvData = {
  it: {
    personal: {
      name: "Emanuel Pistarà",
      title: "Senior Front-end Engineer",
      citizenship: "italiana",
      birthDate: "5 ottobre 1990",
      city: "Milano",
      phone: "3295350545",
      email: "emanuelpistara@gmail.com"
    },

    about: {
      description: "Con oltre sette anni di esperienza nello sviluppo Front-end enterprise, mi occupo di progettare e realizzare applicazioni complesse in contesti multi-team. Ho sviluppato una competenza specifica nella progettazione di Design System — dalla component library alla documentazione tecnica — e nell'architettura di interfacce scalabili e accessibili. Negli ultimi anni integro l'Intelligenza Artificiale nei processi di sviluppo, progettando agenti AI e workflow basati su LLM per l'automazione dei processi aziendali. Affianco queste competenze a una solida sensibilità per il design, maturata attraverso un percorso in Graphic Design che informa ancora oggi il mio approccio alla qualità visiva e all'esperienza utente."
    },

    experienceSteps: [
      {
        type: "role",
        timelineLabel: "2019 — oggi",
        period: "2019 - (attuale)",
        role: "Senior Front-end Engineer",
        company: "Accenture",
        description: "Progettazione e sviluppo di applicazioni Front-end enterprise in settori come la Pubblica Amministrazione, il bancario, le telecomunicazioni e i trasporti. Architettura e sviluppo di Design System condivisi tra team multipli tramite Web Components e Storybook. Realizzazione di applicazioni complesse con React e Angular, con attenzione a performance, accessibilità (WCAG) e SEO tecnico. Integrazione di Large Language Models nei workflow aziendali e progettazione di agenti AI per l'automazione dei processi. Pianificazione tecnica, refinement e collaborazione con designer, team di backend e stakeholder."
      },
      {
        type: "capabilities",
        timelineLabel: "Specializzazioni",
        eyebrow: "Aree di competenza",
        title: "Dalla progettazione alla delivery",
        intro: "Competenze distintive maturate su prodotti enterprise complessi, oltre lo sviluppo di singole interfacce.",
        groups: [
          {
            label: "Design Systems",
            items: [
              "Component library",
              "Web Components",
              "Design tokens",
              "Storybook",
              "Documentazione tecnica",
              "Sistemi condivisi"
            ]
          },
          {
            label: "Front-end Engineering",
            items: [
              "Architettura componenti",
              "Performance",
              "WCAG",
              "SEO tecnico",
              "Applicazioni enterprise"
            ]
          },
          {
            label: "AI & Automazione",
            items: [
              "Integrazione LLM",
              "Agenti AI",
              "Workflow aziendali",
              "Azure"
            ]
          }
        ]
      },
      {
        type: "stack",
        timelineLabel: "Stack",
        eyebrow: "Strumenti di lavoro",
        title: "Framework e fondamenta",
        intro: "Tecnologie utilizzate per costruire prodotti complessi, non come elenco di tool.",
        groups: [
          {
            label: "Framework",
            items: ["React", "Angular"]
          },
          {
            label: "Linguaggi & styling",
            items: ["TypeScript", "JavaScript", "HTML5", "CSS3", "SASS"]
          },
          {
            label: "Sistemi condivisi",
            items: ["Storybook", "Web Components"]
          }
        ]
      }
    ],

    education: [
      {
        degree: "Laurea in Graphic Design (Comunicazione d'Impresa)",
        institution: "Accademia di Belle Arti (AFAM) - Catania",
        grade: "104/110",
        subjects: "Progettazione Grafica, Storia e Metodo dei Mass Media, Web Design, Fotografia, Metodologia Progettuale della Comunicazione Visiva, Advertising, Copywriting, Informatica per la grafica."
      },
      {
        degree: "Perito Informatico (Abacus)",
        institution: "Istituto Tecnico Industriale - Catania",
        grade: "",
        subjects: ""
      },
      {
        degree: "Graphic Designer",
        institution: "Attività in proprio",
        grade: "",
        subjects: "Progettazione dell'identità visiva per clienti privati e aziendali. Questo periodo ha consolidato la sensibilità per il design e la coerenza visiva che informa ancora oggi il mio approccio alla Front-end engineering e alla progettazione di Design System."
      }
    ],

    languages: [
      {
        language: "Italiano",
        level: "Madre lingua"
      },
      {
        language: "Inglese",
        level: "Buona conoscenza (B2)"
      }
    ]
  },

  en: {
    personal: {
      name: "Emanuel Pistarà",
      title: "Senior Front-end Engineer",
      citizenship: "Italian",
      birthDate: "October 5, 1990",
      city: "Milan",
      phone: "+39 3295350545",
      email: "emanuelpistara@gmail.com"
    },

    about: {
      description: "With over seven years of experience in enterprise Front-end development, I design and build complex applications in multi-team environments. I have developed deep expertise in Design System engineering — from component libraries to technical documentation — and in architecting scalable, accessible interfaces. In recent years, I have integrated Artificial Intelligence into development processes, designing AI agents and LLM-based workflows for enterprise process automation. I combine these skills with a strong design sensibility, shaped by a background in Graphic Design that still informs my approach to visual quality and user experience."
    },

    experienceSteps: [
      {
        type: "role",
        timelineLabel: "2019 — present",
        period: "2019 - (current)",
        role: "Senior Front-end Engineer",
        company: "Accenture",
        description: "Design and development of enterprise Front-end applications across sectors including Public Administration, banking, telecommunications, and transportation. Architecture and development of shared Design Systems across multiple teams, leveraging Web Components and Storybook. Development of complex applications with React and Angular, with a focus on performance, accessibility (WCAG), and technical SEO. Integration of Large Language Models into enterprise workflows and design of AI agents for process automation. Technical planning, refinement and collaboration with designers, backend teams and stakeholders."
      },
      {
        type: "capabilities",
        timelineLabel: "Specializations",
        eyebrow: "Areas of expertise",
        title: "From design to delivery",
        intro: "Distinctive capabilities built on complex enterprise products, beyond building individual interfaces.",
        groups: [
          {
            label: "Design Systems",
            items: [
              "Component library",
              "Web Components",
              "Design tokens",
              "Storybook",
              "Technical documentation",
              "Shared systems"
            ]
          },
          {
            label: "Front-end Engineering",
            items: [
              "Component architecture",
              "Performance",
              "WCAG",
              "Technical SEO",
              "Enterprise applications"
            ]
          },
          {
            label: "AI & Automation",
            items: [
              "LLM integration",
              "AI agents",
              "Enterprise workflows",
              "Azure"
            ]
          }
        ]
      },
      {
        type: "stack",
        timelineLabel: "Stack",
        eyebrow: "Working tools",
        title: "Frameworks and foundations",
        intro: "Technologies used to build complex products — not as a list of tools.",
        groups: [
          {
            label: "Frameworks",
            items: ["React", "Angular"]
          },
          {
            label: "Languages & styling",
            items: ["TypeScript", "JavaScript", "HTML5", "CSS3", "SASS"]
          },
          {
            label: "Shared systems",
            items: ["Storybook", "Web Components"]
          }
        ]
      }
    ],

    education: [
      {
        period: "2011 - 2018",
        degree: "Bachelor's Degree in Graphic Design (Corporate Communication)",
        institution: "Academy of Fine Arts (AFAM) - Catania",
        grade: "104/110",
        subjects: "Graphic Design, History and Method of Mass Media, Web Design, Photography, Visual Communication Design Methodology, Advertising, Copywriting, Computer Graphics."
      },
      {
        period: "2005 - 2011",
        degree: "IT Technician Diploma (Abacus)",
        institution: "Technical Industrial Institute - Catania",
        grade: "",
        subjects: ""
      },
      {
        period: "2017 - 2019",
        degree: "Graphic Designer",
        institution: "Self-employed",
        grade: "",
        subjects: "Visual identity design for private and corporate clients. This period consolidated the design sensibility and visual consistency that still informs my approach to Front-end engineering and Design System development."
      }
    ],

    languages: [
      {
        language: "Italian",
        level: "Mother tongue"
      },
      {
        language: "English",
        level: "Good knowledge (B2)"
      }
    ]
  }
};
